/**
 * @author David Oravec<xorave06@stud.fit.vutbr.cz>
 */
import React from 'react';
import {Alert, Button, CircularProgress, Grid, TextField, Typography} from "@mui/material";

function ChangeForm(props) {
    const {what, whatText, setNew, setNewAgain, setOld, submit, isSubmited,
        oldText, newText, newTextAgain, errors, helperTextNew, helperTextAgain, values, submitInfo
    } = props

    return (
        <form style={{margin: "0 auto", maxWidth: 300}}>
            <Grid container justifyContent={"center"} alignItems={"center"} spacing={2}>
                <Grid item xs={12}>
                    <Typography variant={"h4"} component={"h4"} textAlign={"center"}>Zmeniť {whatText}</Typography>
                    {submitInfo.text !== "" && submitInfo.status !== "" ? <Alert severity={submitInfo.status}>{submitInfo.text}</Alert>:<></>}
                </Grid>
                <Grid item xs={12}>
                    <TextField
                        value={values.old}
                        error={errors.old}
                        id={what+'-old'}
                        label={oldText}
                        placeholder={oldText}
                        onChange={setOld}
                        disabled={isSubmited}
                        type={what}
                        fullWidth
                    />
                </Grid>
                <Grid item xs={12}>
                    <TextField
                        value={values.new}
                        error={errors.new}
                        id={what+'-new'}
                        type={what}
                        label={newText}
                        placeholder={newText}
                        onChange={setNew}
                        disabled={isSubmited}
                        fullWidth
                        helperText={errors.new ? helperTextNew: ""}
                    />
                </Grid>
                <Grid item xs={12}>
                    <TextField
                        value={values.newAgain}
                        error={errors.newAgain}
                        id={what+'-newAgain'}
                        type={what}
                        label={newTextAgain}
                        placeholder={newTextAgain}
                        onChange={setNewAgain}
                        disabled={isSubmited}
                        fullWidth
                        helperText={errors.newAgain ? helperTextAgain: ""}
                    />
                </Grid>

                <Grid item xs={12}>
                    <Button
                        variant={"contained"}
                        disabled={isSubmited}
                        onClick={submit}
                        fullWidth
                        endIcon={isSubmited ? <CircularProgress size={10}/> : ""}
                    >Zmeniť {whatText}</Button>
                </Grid>
            </Grid>
        </form>
    );
}

export default ChangeForm;